/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { Modal } from 'antd-mobile'
// icon
import GuideCharacter from '@assets/images/bg/character/first-bet-characte-02.png'
import { GmoneyIco } from '@shared/Icon/MoneyIcon'
// css
import { ModalBg } from '@styles/base.style'
import { Button } from '@styles/button.style'
import { observer } from 'mobx-react'
import useRootStore from '@store/useRootStore'
import { AdvDialogBtnWrap, AdvDialogStyle } from '@styles/modal'
import { GuideWrap, GuideImgWrap } from '../index.style'


const GuideCompletePopup: React.FC = props => {
  const { globalStore } = useRootStore()
  const { visibleGuideCompletePopup, getGuideBonus } = globalStore

  const onCloseModal = async () => {
    globalStore.setVisibleGuideCompletePopup(false)
  }

  const guideBonus = getGuideBonus().toLocaleString()

  return (
    <Fragment>
      <Modal
        transparent
        visible={visibleGuideCompletePopup}
        maskClosable={false}
        onClose={onCloseModal}
        className="adv-new-dialog box-type big-size character-popup"
        wrapClassName="guide-notice-popup"
        css={AdvDialogStyle}
      >
        {/* 캐릭터 영역 */}
        <GuideImgWrap>
          <div className="guide-circle">
            <img src={GuideCharacter} alt="캐릭터" className="guide-character"/>
          </div>
          <p className="guide-txt">
            좌측 상단 서랍 메뉴를 통해
            <br/>
            언제든 가이드를 확인할 수 있습니다.
          </p>
        </GuideImgWrap>

        <GuideWrap>
          <div className="guide-box complete">
            <span className="point-txt point-color--orange--modal">보너스 머니 {guideBonus}<GmoneyIco/></span>가<br/>
            메세지 함으로 지급되었습니다.
          </div>
        </GuideWrap>

        <AdvDialogBtnWrap className="adv-dialog-btn-wrap">
          <Button secondary onClick={onCloseModal} className="single-btn">
            확인
          </Button>
        </AdvDialogBtnWrap>

        <ModalBg onClick={onCloseModal}/>

      </Modal>
    </Fragment>
  )
}

export default observer(GuideCompletePopup)
